const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

const checkIfInView = ref => {
  const rect = ref?.current?.getBoundingClientRect()
  if (!rect) {
    return
  }
  if (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
    ref.current.classList.add('in-view')
  }
}

export {
  isIOS,
  checkIfInView,
}